var validationGroupName;

$(function () {
    // Override jquery email validation (it does not required a domain by default)
    $.validator.addMethod('email', function (value, element) {
        return this.optional(element) || /^[A-Za-z0-9!#$%&'*+/=?_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?$/.test(value);
    }, "Email address is invalid");

    $("#frmMain").submit(function () {
        $(":input").each(function () {
            if (!!$(this).val()) {
                $(this).val($(this).val().replace(/[<>]/, ''));
            }
        });
		var pageCommand = $("#frmMain #pageCommand").val();
		var $clicked = $("input[name=" + pageCommand + "]");
		var btnClicked = $("a[name=" + pageCommand + "]");
		validationGroupName = $clicked.data("val-group") || btnClicked.data("val-group");
        BindIgnoreHandler();  // rewire in case it's been taken over

        var skipValidation = $("#skipValidation").val();
        if (skipValidation != null && skipValidation == true)
            pep.validation.validator.settings.onsubmit = false;
    });
    $("select").change(function () {
        //Hack to refresh dropdowns for Nexus 4
        if (isMobile.Android())
            $(this).blur().focus().blur();
    });
    $(function () {
        // Yes, this is a Ready event inside a Ready event - it's to ensure that this runs after other Form submit events
        $("#frmMain").submit(function () {
            if (validationGroupName != null && validationGroupName.length > 0)
                $("label.capError:not(#" + validationGroupName + " label)").removeClass("capError");
        });
    });
});

function BindIgnoreHandler() {
    pep.validation.validator.settings.ignore = ignoreHandler;
}

//This is called recursively on masked displayField so that the actual data (hidden) field is validated based on the visibility/enabled of the display field.
//Because of this, the default ignoreDisplayOnly param is true, but when we recursively call to take the properties of the hidden field, we must not
//return false just because it is a display field.
function ignoreHandler(i, elem, ignoreDisplayOnly) {
    var $elem = $(elem);

    if ($elem.hasClass("ignore")) return true;

    if (ignoreDisplayOnly == null) {
        ignoreDisplayOnly = true;
    }

    var outsideValidationGroup = false;
    if (validationGroupName != null && validationGroupName.length > 0) {
        outsideValidationGroup = $("#" + validationGroupName).has($elem).length == 0
    }

    var isDisplayOnlyField = $elem.attr('data-forcontrol') != null && $elem.attr('data-forcontrol').length > 0;
    var hidden = $elem.is(":hidden");
    var disabled = $elem.is(":disabled");
    var hiddenValidator = $elem.hasClass('validateHidden');

    if (outsideValidationGroup || (isDisplayOnlyField && ignoreDisplayOnly)) {
        return true;
    }
    if (hiddenValidator) {
        var $displayField = $('body').find('[data-forcontrol=' + $elem.attr('id') + ']');
        if ($displayField != null && $displayField.length > 0) {
            return ignoreHandler(i, $displayField, false);
        }
        return false;
    }
    return hidden || disabled;
};
